import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.module.education');
import { OnInit, OnChanges, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-portal-lpsysadmin-support-module-education',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminSupportModuleEducationComponent implements OnInit, OnChanges {
    @Input() program_id: string = '';
    @Input() module_id: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public loaded: boolean = false;
    public module: any = null;
    public sessions: any[] = [];
    public selectedSession: any = null;
    public attendance: any[] = [];

    public tab: string = 'curriculum'; // curriculum | attendance

    public showSessionEditor: boolean = false;
    public editingSession: any = null;

    public sessionStatusMap: any = {
        planned: { label: '예정', cls: 'bg-blue-50 text-blue-700' },
        ongoing: { label: '진행중', cls: 'bg-emerald-50 text-emerald-700' },
        done: { label: '완료', cls: 'bg-zinc-100 text-zinc-700' },
        cancelled: { label: '취소', cls: 'bg-red-50 text-red-700' },
    };
    public attStatusMap: any = {
        registered: { label: '등록', cls: 'bg-zinc-100 text-zinc-700' },
        attended: { label: '참석', cls: 'bg-emerald-100 text-emerald-800' },
        absent: { label: '결석', cls: 'bg-red-100 text-red-800' },
        excused: { label: '공결', cls: 'bg-amber-100 text-amber-800' },
    };

    public async ngOnInit() {
        await this.service.init();
        await this.reload();
    }

    public async ngOnChanges() {
        if (this.module_id) await this.reload();
    }

    private _emptySession() {
        return {
            module_id: this.module_id,
            program_id: this.program_id,
            round_no: (this.sessions.length || 0) + 1,
            title: `교육 ${(this.sessions.length || 0) + 1}회차`,
            start_at: '', end_at: '', location: '', online_url: '',
            instructor: '', materials: '', status: 'planned'
        };
    }

    private async reload() {
        if (!this.module_id) return;
        this.loaded = false;
        await this.service.render();
        const r = await wiz.call('get_module', { module_id: this.module_id });
        if (r.code != 200) {
            this.service.alert.show({ title: '오류', message: r.data?.message || '모듈 로딩 실패', action: '확인' });
            return;
        }
        this.module = r.data.data;
        await this.loadSessions();
        this.loaded = true;
        await this.service.render();
    }

    public async loadSessions() {
        const r = await wiz.call('list_sessions', { module_id: this.module_id });
        if (r.code == 200) this.sessions = r.data.rows || [];
        await this.service.render();
    }

    public async setTab(t: string) { this.tab = t; await this.service.render(); }

    // ===== Sessions =====
    public openSessionCreate() {
        this.editingSession = this._emptySession();
        this.showSessionEditor = true;
        this.service.render();
    }

    public openSessionEdit(s: any) {
        this.editingSession = JSON.parse(JSON.stringify(s));
        this.showSessionEditor = true;
        this.service.render();
    }

    public openSessionClone(s: any) {
        this.editingSession = JSON.parse(JSON.stringify(s));
        delete this.editingSession.id;
        this.editingSession.round_no = (this.sessions.length || 0) + 1;
        this.editingSession.title = (s.title || '').replace(/\d+회차/, `${this.editingSession.round_no}회차`);
        if (!this.editingSession.title.includes('회차')) {
            this.editingSession.title = `${this.editingSession.title} ${this.editingSession.round_no}회차`;
        }
        this.editingSession.start_at = '';
        this.editingSession.end_at = '';
        this.editingSession.status = 'planned';
        this.showSessionEditor = true;
        this.service.render();
    }

    public closeSessionEditor() {
        this.showSessionEditor = false;
        this.editingSession = null;
        this.service.render();
    }

    public async saveSession() {
        if (!this.editingSession) return;
        this.editingSession.round_no = Number(this.editingSession.round_no) || 1;
        const isNew = !this.editingSession.id;
        const r = isNew
            ? await wiz.call('create_session', { data: JSON.stringify(this.editingSession) })
            : await wiz.call('update_session', { id: this.editingSession.id, data: JSON.stringify(this.editingSession) });
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        this.showSessionEditor = false;
        await this.loadSessions();
    }

    public async deleteSession(s: any) {
        if (!confirm(`${s.title} 회차를 삭제하시겠습니까?`)) return;
        const r = await wiz.call('delete_session', { id: s.id });
        if (r.code != 200) {
            this.service.alert.show({ title: '삭제 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        if (this.selectedSession && this.selectedSession.id === s.id) {
            this.selectedSession = null;
            this.attendance = [];
        }
        await this.loadSessions();
    }

    // ===== Attendance =====
    public async selectSession(s: any) {
        this.selectedSession = s;
        const r = await wiz.call('list_attendance', { session_id: s.id });
        if (r.code == 200) this.attendance = r.data.rows || [];
        await this.service.render();
    }

    public async bulkRegister() {
        if (!this.selectedSession) return;
        if (!confirm('선정된 모든 기업을 이 회차에 등록하시겠습니까?')) return;
        const r = await wiz.call('bulk_register', { session_id: this.selectedSession.id });
        if (r.code != 200) {
            this.service.alert.show({ title: '등록 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        await this.selectSession(this.selectedSession);
    }

    public async setAttendance(att: any, status: string) {
        const r = await wiz.call('mark_attendance', {
            session_id: att.session_id, application_id: att.application_id, status
        });
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        att.status = status;
        await this.service.render();
    }

    public sessionStatusInfo(s: string) {
        return this.sessionStatusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' };
    }
    public attStatusInfo(s: string) {
        return this.attStatusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' };
    }

    public attendanceRate(): string {
        if (!this.attendance.length) return '0';
        const att = this.attendance.filter(x => x.status === 'attended').length;
        return Math.round(att / this.attendance.length * 100).toString();
    }
}

export default PortalLpsysadminSupportModuleEducationComponent;